(function ($, root, undefined) {
    
    $(function () {

    // LOCATION SELECTOR
    function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split("&"),
          sParameterName,
          i;
      
        for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split("=");
      
          if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined
              ? true
              : decodeURIComponent(sParameterName[1]);
          }
        }
        return false;
    }
    if (getUrlParameter("loc") == '1') {
        Cookies.set("seasn_user_loc", 'true');
    }

    var status = Cookies.get("seasn_user_loc");  
    $('.c-selector__btn').on('click', function(){
        Cookies.set("seasn_user_loc", 'true');
        $('body').removeClass('show-location');
    });
    function country_selector(){
        if (status != 'true' ){         
            // $.getJSON("https://geolocation-db.com/json/697de680-a737-11ea-9820-af05f4014d91", function (data) {   
            // var my_country = data.country_code;         
            // if(my_country != 'GB'){

            //};
            //});
            $('body').addClass('show-location');
            
        };
    }
    
    $('.country-url').click(function(e){
        e.preventDefault();
        $('body').addClass('show-location');
    })
    $('.c-selector__close').click(function(){
        $('body').removeClass('show-location');
        Cookies.set("seasn_user_loc", 'true');
    });
    $('.c-selector__backdrop').click(function(){
        $('body').removeClass('show-location');
        Cookies.set("seasn_user_loc", 'true');
    })
    country_selector();

    // Header
    $(window).on('load resize',function(){
        let headerH = $('.header-section').outerHeight();
        $('.page-header-product-section').css('padding-top',headerH+'px');
    })
    $('.phone-nav').click(function () {
        $("body").toggleClass("navShown");
    });

    if ($(window).width() < 992){
        $(".main-nav .mobi ul li.has-sub-menu > a").on("click touch", function (e) {
            e.preventDefault();
            $('.main-nav').addClass("subnavShown")
            $(this).next().addClass("active")

                // $(".nav-inner").scrollTop(0);
            
        });

        $(".close-sub-menu, .phone-nav").on("click touch", function (e) {
            e.preventDefault();
            $('.main-nav').removeClass("subnavShown")
            $('.sub-menu').removeClass("active")
            
        });

        
    }


    var header = new Headroom(document.querySelector('header'), {
        tolarence: 80,
        offset: 155,
        classes: {

            initial: 'headroom',
            pinned: 'slidedown',
            unpinned: 'slideup'
        }
    });
    header.init();

    // var split = new SplitText(".content h1, .content h2, .content h3, .content h4, .content p", { type: "lines", linesClass: "line" });
    // $(".content .line, .review .line").wrap('<div class="line-wrapper">');

    // gsap.utils.toArray(".line").forEach((el) => {
    //     gsap.from(el, {
    //         y: -100,
    //         autoAlpha: 0,
    //         duration: 0.8,
    //         stagger: 0.1,
    //         ease: "power1",
    //         scrollTrigger: {
    //             trigger: el,
    //             start: "top 80%",
    //             toggleActions: "play none none none"
    //         }
    //     });
    // });

    // $(".content").css("opacity", 1);

                
    $('.social-marquee-slider').marquee({ // Initialize marquee
        direction: 'left',
        duration: 35000,
        gap: 0,
        delayBeforeStart: 0,
        duplicated: true,
        startVisible: true
    })

    $('.testimonial-carousel').marquee({ // Initialize marquee
        direction: 'left',
        duration: 35000,
        gap: 0,
        delayBeforeStart: 0,
        duplicated: true,
        startVisible: true,
        pauseOnHover: true
    })

    if($(".accordion-item").length){
    $(".accordion > .accordion-item:first-child .accordion-content-row").eq(0).show().addClass("active");
    // $(".accordion-item").eq(0).addClass("active")

     $(".accordion-item").each(function () {
            var $this = $(this);
            $this.find(" > .accordion-title").on("click touch", function () {
                $(".accordion-item").removeClass("active")
                $(".accordion-item .accordion-content-row").slideUp();
                if ($this.find(".accordion-content-row:visible").length) {
                    $(".accordion-item").removeClass("active")
                    $(".accordion-item .accordion-content-row").slideUp();
                } else {
                    $this.addClass("active")
                    $(".accordion-item .accordion-content-row").slideUp();
                    $this.find(" > .accordion-content-row").slideDown();
                }
            })
        })
    }
    


    if($(".product-visual-container").length){

        $('.product-visual-container').slick({
            dots: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                }
            ]
        })
    }

    if($(".featured-video-wrapper").length){

        $('.featured-video-wrapper').slick({
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1.33,
            slidesToScroll: 1,
            arrows: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                }
            ]
        })
    }

    if($(".slider-3d-section").length){

        $3dSliderContainer = $('.slider-3d-section');
        $3dSlider = $('.slider-3d');

        var slider3d = $3dSlider.slick({
            dots: false,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            centerMode : true,
            centerPadding: '50px',
            infinite: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        centerPadding: '16px',
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        centerPadding: '16px',
                    }
                }
            ]

        })

        $3dSliderContainer.on('click', '.slider-3rd-next', function () {
            slider3d.slick('slickNext');
        });

        $3dSliderContainer.on('click', '.slider-3rd-prev', function () {
            slider3d.slick('slickPrev');
        });
    }


    $(".ModalTrigger").click(function(e){
        e.preventDefault();
        
        $('body').addClass('modalShown');
        $('.modal-bg').fadeIn();

        var activeTab = $(this).attr('href');
        $(activeTab).fadeIn();
        return false;
    });

    $(".modal-close, .modal-bg").on('click',function(e){
        e.preventDefault();
        
        $('body').removeClass('modalShown');
        $('.modal-bg').fadeOut();
        $('.modal-container').fadeOut();
    });

    $(".nav__url_cart").on("click touch", function (e) {
        e.preventDefault();
        $('body').addClass('cartShown cartEmpty');
        $('.modal-bg').fadeIn();


    }) 

    $(".showCart").on("click touch", function (e) {
        e.preventDefault();
        $('body').addClass('cartShown cartPopulated');
        $('.modal-bg').fadeIn();

    })

    $(document).on('click', '.cart-close, .modal-bg', function(){
        $('body').removeClass('cartShown');
        $('body').removeClass('cartPopulated');
        $('body').removeClass('cartEmpty');
        $('.modal-bg').fadeOut();
    });
    $(document).on('click', '.close-cart-btn, .modal-bg', function(){
        $('body').removeClass('cartShown');
        $('body').removeClass('cartPopulated');
        $('body').removeClass('cartEmpty');
        $('.modal-bg').fadeOut();
    });


    


    $(".tab-trigger a").click(function(event) {
        event.preventDefault(); 
        $(".tab-trigger a").removeClass('active-tab');
        $(this).addClass('active-tab');

        var targetClass = $(this).attr('href').substring(1);
        var tabClass = 'show-table-item'; 

        $('.' + tabClass).removeClass(tabClass);

        $('.' + targetClass).addClass(tabClass);
    });

        let lenis;

    const initSmoothScrolling = () => {
       let lenis = new Lenis({
            lerp: 0.075,
            smoothWheel: true
        });

        lenis.on('scroll', ScrollTrigger.update);

        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);
    };

    // GSAP Animations Initialization
    function initGsapAnimations() {   

    // Cache jQuery selections
    var $positionedTopElements = $(".postioned-top");
    var $fixedSlider = $(".fixed-slider");
    var $postionedBtmImg = $(".float-img img");

    if ($positionedTopElements.length > 0) {
        $positionedTopElements.each(function () {
            var $element = $(this);
            var initialX = $element.hasClass("left") ? -$element.outerWidth() / (window.innerWidth >= 1024 ? 2.5 : 5) : $element.outerWidth() / (window.innerWidth >= 1024 ? 2.5 : 5);
            var initialY = -$element.outerWidth() / (window.innerWidth >= 1024 ? 8 : 12);

            gsap.set($element, {
                x: initialX,
                y: initialY,
                ease: "none",
                willChange: "transform"
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: ".centred-content-section",
                    start: "top center+=50%",
                    end: "bottom center+=15%",
                    scrub: 0.8
                }
            }).to($element, {
                x: 0,
                y: 0,
                ease: "none"
            });
        });
    }

    function initFixedSlider() {
        if ($fixedSlider.length > 0) {
            const panels = gsap.utils.toArray(".slide-section");
            const masterTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: ".fixed-slider",
                    pin: true,
                    start: "top top",
                    end: () => "+=" + (panels.length * window.innerHeight),
                    scrub: 2
                }
            });

            // gsap.set(".animation-container img", { opacity: 0, scale: 1.2 });

            panels.forEach((panel, index) => {
                const tl = gsap.timeline();
                if (index !== 0) gsap.set(panel, { autoAlpha: 0 });

                tl.to(panel, {
                    autoAlpha: 1,
                    duration: 1,
                    ease: "power1.inOut",
                    immediateRender: false,
                    onComplete: () => addInViewClass(panel)
                }).to({}, { duration: 2 });

                const slideInLeftElement = panel.querySelector(".slide-in-left");
                const slideInRightElement = panel.querySelector(".slide-in-right");

                if (slideInLeftElement) {
                    tl.from(slideInLeftElement, {
                        x: -100,
                        autoAlpha: 0,
                        duration: 3,
                        ease: "power2.out"
                    });
                }

                if (slideInRightElement) {
                    tl.from(slideInRightElement, {
                        x: 100,
                        autoAlpha: 0,
                        duration: 3,
                        ease: "power2.out"
                    });
                }

                masterTimeline.add(tl, index > 0 ? "+=2" : 0);
            });
        }
    }

    // function triggerBatchAnimations(panel) {
    //     const images = panel.querySelectorAll(".absolute-img img");
    //     gsap.to(images, {
    //         scrollTrigger: {
    //             trigger: panel,
    //             start: "top center",
    //             toggleActions: "play none none none"
    //         },
    //         opacity: 1,
    //         scale: 1,
    //         duration: 0.5,
    //         ease: "power1.out",
    //         stagger: 0.15
    //     });

    //     ScrollTrigger.create({
    //         trigger: panel,
    //         start: "top bottom",
    //         end: "top top",
    //         onLeaveBack: () => {
    //             gsap.to(images, {
    //                 opacity: 0,
    //                 scale: 1.2,
    //                 duration: 0.5,
    //                 ease: "power1.out"
    //             });
    //         }
    //     });
    // }

    function addInViewClass(panel) {
        const element = panel instanceof jQuery ? panel[0] : panel;
    const images = element.querySelectorAll(".absolute-img img");
        images.forEach((img, index) => {
            setTimeout(() => {
                img.classList.add('inview');
            }, index * 350); // 150ms stagger
        });
        // images.forEach(img => img.classList.add('inview'));

        ScrollTrigger.create({
            trigger: panel,
            start: "top bottom",
            end: "top top",
            onLeaveBack: () => {
                images.forEach(img => img.classList.remove('inview'));
            }
        });
    }

    function setupResponsiveSlider() {
        const mediaQuery = window.matchMedia("(max-width: 991px)");
        mediaQuery.addEventListener("change", handleMediaChange);
        handleMediaChange(mediaQuery);
    }

    function handleMediaChange(e) {
        if (e.matches) {
            if ($fixedSlider.length) {
                function removeInViewClass(panel) {
                    const images = panel.querySelectorAll(".absolute-img img");
                    images.forEach(img => img.classList.remove('inview'));
                }

                $('.slide-section').each(function () {
                    var $this = $(this);
                    var headingH = $this.find('.fixed-heading').outerHeight();
                    $this.find('.slide-inner').css('height', headingH + 'px');
                });

                var slider = $fixedSlider.slick({
                    dots: false,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    fade:true
                });

                $fixedSlider.on('click', '.next-arrow', function () {
                    slider.slick('slickNext');
                });

                $fixedSlider.on('click', '.prev-arrow', function () {
                    slider.slick('slickPrev');
                });

                slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                    removeInViewClass(slick.$slides[currentSlide]);
                });

                slider.on('afterChange', function(event, slick, currentSlide) {
                    addInViewClass(slick.$slides[currentSlide]);
                });

                ScrollTrigger.create({
                    trigger: ".fixed-slider",
                    start: "top bottom",
                    onEnter: () => {
                        addInViewClass(slider.find('.slick-active'));
                    }
                });


            }
        } else {
            initFixedSlider();
        }
    }

    if ($postionedBtmImg.length > 0) {
        gsap.to($postionedBtmImg, {
            y: "random(-20, 20)",
            zIndex: 22,
            duration: 2,
            ease: "none",
            yoyo: true,
            repeat: -1,
            willChange: "transform"
        });
    }

    function parallaxAnimation() {
        gsap.utils.toArray(".parallax-img").forEach(function (container) {
            let image = container.querySelector("img");

            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    scrub: true,
                    pin: false
                }
            });

            tl.from(image, {
                yPercent: -30,
                ease: "none",
                willChange: "transform"
            }).to(image, {
                yPercent: 30,
                ease: "none"
            });
        });

        // let resizeTimeout;
        // window.addEventListener("resize", () => {
        //     clearTimeout(resizeTimeout);
        //     resizeTimeout = setTimeout(() => {
        //         gsap.utils.toArray(".parallax-img img").forEach(fitImage);
        //     }, 200);
        // });

        // function fitImage(img, marginFactor) {
        //   let sx = img.parentNode.offsetWidth / img.naturalWidth,
        //       sy = img.parentNode.offsetHeight * (1 + Math.abs(marginFactor)) / img.naturalHeight,
        //       scale = Math.max(sx, sy),
        //       w = Math.ceil(img.naturalWidth * scale),
        //       h = Math.ceil(img.naturalHeight * scale);
        //     gsap.set(img, {width: w, height: h, top: Math.ceil((img.parentNode.offsetHeight - h) / 2), left: 0, position: "absolute"});
        // }
    }

    setupResponsiveSlider();
    parallaxAnimation();



    // ScrollTrigger.batch(".stagReveal", {
    //     start: "top 80%",
    //     onEnter: batch => gsap.fromTo(batch, { opacity: 0, y: -100 }, { opacity: 1, y: 0, stagger: 0.15, duration: 1, ease: "power1.out" }),
    //     onLeaveBack: batch => gsap.to(batch, { opacity: 0, y: -100, stagger: 0.15, duration: 1, ease: "power1.in" })
    // });

    // gsap.utils.toArray(".stagReveal").forEach((stagElement, index) => {
    //     gsap.fromTo(stagElement, 
    //         { opacity: 0, y: -100 }, 
    //         { 
    //             opacity: 1, 
    //             y: 0, 
    //             duration: 1, 
    //             ease: "power1.out",
    //             scrollTrigger: {
    //                 trigger: stagElement,
    //                 start: "top 80%",
    //                 toggleActions: "play none none none"
    //             },
    //             delay: index * 0.15 // Stagger effect
    //         }
    //     );
    // });


    function countAllStats() {
      let stats = $(".counter").toArray();

      stats.forEach(stat => {
        var count = $(stat),
          zero = { val: 0 },
          num = count.data("number"),
          split = (num + "").split("."), // to cover for instances of decimals
          decimals = split.length > 1 ? split[1].length : 0;

        // If it's not a number, skip counting
        if (typeof num == 'number') {
          gsap.to(zero, {
            val: num,
            duration: 2,
            scrollTrigger: stat,
            onUpdate: function() {
              let numText = zero.val.toFixed(decimals);
              numText = numText.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
              count.text(numText);
            }
          });
        } else {
          count.text(num);
        }
      });
    }

    // Call the function to start the counting animations
    countAllStats();
    

    if ($('.centered-img-tile-section').length > 0) {
        // Animate the left image
        gsap.to(".left-tile", {
          y: 200,
          ease: "none",
          scrollTrigger: {
            trigger: ".centered-img-tile-inner",
            start: "top top",
            end: "bottom top", 
            scrub: true,
            onUpdate: self => {
              gsap.set(self.trigger, { force3D: true }); // Force 3D rendering
            }
          },
        });

        // Animate the right image
        gsap.to(".right-tile", {
          y: -200, 
          ease: "none",
          scrollTrigger: {
            trigger: ".centered-img-tile-inner", 
            start: "top top", 
            end: "bottom top", 
            scrub: true, 
            onUpdate: self => {
              gsap.set(self.trigger, { force3D: true }); // Force 3D rendering
            }
          },
        });
    }

}



    $('body').imagesLoaded({ background: true }, function() {
        initGsapAnimations();
    });

        
    });//End jQqery ready

    $(window).on("load",function() {

        
    });//End jQuery load

    
})(jQuery, this);

function increaseCount(e, el) {
    e.preventDefault();
    var input = el.previousElementSibling;
    var value = parseInt(input.value, 10);
    value = isNaN(value) ? 0 : value;
    value++;
    input.value = value;

    var decreaseButton = el.previousElementSibling.previousElementSibling;
    decreaseButton.classList.remove('button-opacity');
}

function decreaseCount(e, el) {
    e.preventDefault();
    var input = el.nextElementSibling;
    var value = parseInt(input.value, 10);
    value = isNaN(value) ? 0 : value;

    if (value > 1) {
        value--;
        input.value = value;

        // Add or remove the 'button-opacity' class based on the value
        if (value === 1) {
            el.classList.add('button-opacity');
        } else {
            el.classList.remove('button-opacity');
        }
    }
    
}










// cart
$( ".single__atc").on("click", function (e) {
    e.preventDefault();
    $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          data: $('.single-product-form').serialize(),
          success: function(data) {
            get_cart_details();
            $('body').addClass('cartShown');
            $('.modal-bg').fadeIn();
            // $('.cart-backdrop').fadeIn();
          },
          error: 'addToCartFail'
      });
      
  });
  
  
  
    //   Add
    function get_cart_details(){
      var current_selected = $('.product-variants').val();
      fetch("?section_id=cart-drawer")
        .then((response) => response.text())
        .then((cartData) => {
          var cart_html = $(cartData);

          var cart_data = $(".cart-drawer-wrap", cart_html);
          $(".cart-drawer-wrap").replaceWith(cart_data);

        //   var cart_count = $(".cart-item-counter", cart_html);
        //   $(".cart-item-counter").replaceWith(cart_count);

        //   var cart_items = $(".cart-body", cart_html);
        //   $(".cart-body").replaceWith(cart_items);

        //   var cart_items = $(".cart-footer", cart_html);
        //   $(".cart-footer").replaceWith(cart_items);
        });
    
        fetch("?section_id=header")
        .then((response) => response.text())
        .then((headerData) => {
          var cart_html = $(headerData);
          var cart_count = $(".cart-trigger", cart_html);
          $(".cart-trigger").replaceWith(cart_count);
        });
    };
    
    
    // Increase and decrease
    function increaseItem(e, el) {
      var $input = el.previousElementSibling;
      var value = parseInt($input.value, 10);
      value = isNaN(value) ? 0 : value;
      value++;
      $input.value = value;            
      change_qty($input);
    }
    
    function decreaseItem(e, el) {
      var $input = el.nextElementSibling;
      var value = parseInt($input.value, 10);
      if (value > 1) {
          value = isNaN(value) ? 0 : value;
          value--;
          $input.value = value;            
          change_qty($input);
      }
    }
    
    //   change quantity
    function change_qty($input){
      var variant_id= $($input).attr("data-id");
      var quantity= $($input).val();          
      var data = { updates: {} };
      data.updates[variant_id] = quantity;
      jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(res) {               
          get_cart_details();
        }
      });
    };
    
    
    
    //   Remove
    function itemRemove(e , el){
      e.preventDefault();
      var variant_id = $(el).attr('data-id');
      console.log(variant_id);
      var data = { updates: {} };
      data.updates[variant_id] = '0';
      jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(res) {
          get_cart_details();
        }
      });
          //  $(el).parent().parent().remove();
    }